export const connection: any = {
  data: {},
  queryVariables: "$integrationId: String!",
  queryParams: "integrationId: $integrationId",
  customerId: null,
  enabledServices: {},
};
